import UserService from "../services/users";

const uploadFile = (url, file, dataURL, progress) => {
    return new Promise((resolve, reject) => {
        let fileType = file.name.split('.').pop().toLowerCase();
        var fileName = '' + (new Date().getTime()) + '-' + file.name.toLowerCase().replace('.' + fileType, '');

        fileName = fileName + '.' + fileType;
        const formData = new FormData();

        if (dataURL) {
            formData.append('base64file', dataURL);
        } else {
            formData.append('file', file, fileName);
        }
        formData.append('filename', fileName);

        let prepHeaders = {};
        prepHeaders['authorisation'] = 'Bearer ' + UserService.getToken();
        prepHeaders['userid'] = UserService.currentUser()._id;
        var xhr = new XMLHttpRequest();
        xhr.open('POST', url, true);

        Object.keys(prepHeaders).forEach(function (key) {
            xhr.setRequestHeader(key, prepHeaders[key]);
        })

        xhr.upload.onprogress = function (e) {
            if (e.lengthComputable) {
                var percentComplete = Math.round((e.loaded / e.total) * 100);
                progress(percentComplete);
            }
        };

        xhr.onload = function () {
            progress(100);
            if (xhr.status === 200) {
                resolve(xhr.response);
            } else {
                reject(xhr);
            }
        }

        xhr.onerror = function(){
            reject();
        }

        xhr.send(formData);
    })
}

export default { uploadFile }